@if (
  {
    title: title()
  };
  as STATE
) {
  <header class="page-header">
    <section class="page-header__callback" (click)="goBack()">
      <mat-icon svgIcon="dgi-arrow-left-back" color="primary"></mat-icon>
      <span>Retour à la liste</span>
    </section>

    <section class="page-header__title">
      <span class="page-header__title-text">{{ STATE.title }}</span>
    </section>
  </header>
}
